import * as _ from 'underscore';

const EMAIL_REGEXP:RegExp = /^[^@ ]+@[^@ ]+$/;

export module EmailValidationHelper {

  export function isValidEmail(email:string) {
    return !containsUnicode(email) && EMAIL_REGEXP.test(email);
  }

  export function getInvalidEmails(emails:string[]) {
    return _.reject(emails, isValidEmail);
  }

  // the server will reject addresses that do not correspond to RFC 822: see ValidatorUtils.java
  // RFC 822 valid chars per https://www.cs.tut.fi/~jkorpela/rfc/822addr.html are all the printable ASCII chars
  // ascii printable chars decimal range = 32 -> 126 https://en.wikipedia.org/wiki/ASCII#Printable_characters
  // frontend check because of TFS 598748: don't let the user send a known invalid address
  function containsUnicode(email:string){
      for (let i = 0; i < email.length; i++){
        const charCode: number = email[i].charCodeAt(0);
        if (charCode < 32 || charCode > 126) {
          return true;
        }
      }
      return false;
    }

}
